export default __webpack_public_path__ + "static/media/Basketball_04.569497a2.png";